export const HEADER_TITLE = {
  EMPLOYEE_PROFILE: 'Employee Profile',
  ATTENDANCE_EMPLOYEE: 'Attendance Employees',
  ATTENDANCE_TIME_TRACKING: 'Attendance Time Tracking',
  ATTENDANCE_OVERVIEW: 'Attendance Overview',
  ATTENDANCE_VIOLATIONS: 'Attendance Violations',
  TIME_EDIT_REQUESTS: 'Time Edit Req',
  DELETE_CONFIRM: 'Are you sure you want to delete this file?',
  DELETE_FILE: 'Delete File'
};

export const ANNOUNCEMENT_TITLE = {
  DELETE_ANNOUNCEMENT: 'Delete Announcement',
  DELETE_ANNOUNCEMENT_CONFIRM: 'Are you sure you want to delete this announcement?'
};

export const NOTE_TITLE = {
  DELETE_NOTE: 'Delete Note',
  DELETE_NOTE_CONFIRM: 'Are you sure you want to delete this note?'
};
